import {getMyAccountDetailsAction} from '../../../redux/actions/Actions';
import {getAPICall, postAPICall} from '../../../services/apiCallsHandler';
import {
  dateFormatter,
  enqueueToastUI,
  formatCurrency,
} from '../../../utils/util';

import {Button, CircularProgress, useToastProvider} from '@deere/fuel-react';
import Download from '@mui/icons-material/Download';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';

const SettlementQuoteInfo = (props) => {
  const {enqueueToast} = useToastProvider();
  const {t} = useTranslation();
  const [isLoading, setIsLoading] = React.useState(false);

  React.useEffect(() => {
    if (props.customerDetails === null) {
      getAPICall(
        `myAccount`,
        {
          isCallBack: false,
          errorTag: 'GET_MYACCOUNT_DETAIL',
          redirectToOops: false,
        },
        {
          stateName: 'myAccountDetails',
          actionName: getMyAccountDetailsAction,
        }
      ).then((res) => {
        setIsLoading(false);
        if (res.isError) {
          setIsLoading(false);
        }
      });
    }
  }, []);

  const getFormattedAddress = () => {
    const baseAddress = props.selectedOrg
      ? props.customerDetails.org.find(
          (org) => org.customerId === props.selectedOrg
        )
      : props.customerDetails.personal;
    let data = {};
    data.tradingName = baseAddress.tradingName || baseAddress.fullName;
    data.address = `${
      baseAddress.physicalAddress?.addressLine1 ||
      baseAddress.physicalAddress?.addressLine2
    } \n ${baseAddress.physicalAddress?.city}
      \n ${baseAddress.physicalAddress?.postalCode} \n ${
      baseAddress.physicalAddress?.country
    }`;

    return data;
  };

  const getFormattedEquipments = () => {
    let item;
    let assetsArray =
      props.contractDetails?.accountDetails[props.selectedContract].assets;
    let assetsTemp = assetsArray?.map((asset) => {
      item = {
        equipmentDesc: asset.description || 'NA',
        serialNumber: asset.serialNumber || 'NA',
        registrationNumber: asset.registrationNumber || 'NA',
      };
      return item;
    });
    return assetsTemp;
  };

  const download = async () => {
    setIsLoading(true);
    const customerDetails = getFormattedAddress();
    const equipmentDetails = getFormattedEquipments();

    let payload = {
      type: 'settlementQuote',
      country: props.country,
      documentSubType: props.subType,
      contractReference: +props.selectedContract,
      requestedBy: props.userDetails.name,
      settlementDetails: {
        settlementFigure: formatCurrency(
          props.automateSettlementInfo?.netPayoffAmount
        ),
        validUntil: dateFormatter(props.automateSettlementInfo?.expiryDate),
        settlementDate: dateFormatter(props.automateSettlementInfo?.expiryDate),
        rebate: formatCurrency(props.automateSettlementInfo?.rebateAmount),
        settlementTotal: formatCurrency(
          props.automateSettlementInfo?.netPayoffAmount +
            props.automateSettlementInfo?.rebateAmount
        ),
      },
      customerDetails,
      equipmentDetails,
      quoteDate: props.quoteDate,
    };

    await postAPICall(`docGen`, payload, {
      errorTag: 'FETCH_DOCUMENT_SIGNED_URL',
      redirectToOops: false,
    }).then((res) => {
      if (res.status != 200) {
        enqueueToastUI(
          500,
          enqueueToast,
          '',
          t('SOMETHING_WENT_WRONG_TRY_AGAIN')
        );
      } else if (res.body) {
        if (globalThis.ReactNativeWebView) {
          globalThis.ReactNativeWebView.postMessage(
            JSON.stringify({
              docUrl: res.body.url,
              docName: `JOHNDEERE_DOCUMENT_${new Date().getTime()}.pdf`,
            })
          );
        } else {
          globalThis.open(res.body.url, '_blank');
        }
      }
      setIsLoading(false);
    });
  };

  return props.automateSettlementInfo ? (
    <div className="SettlementQuoteInfo" id="SettlementQuoteInfo">
      {props.automateSettlementInfo?.netPayoffAmount ? (
        <>
          <div>{t('SETTLEMENT_DETAILS_QUOTE_DATE_LABEL')}</div>

          <div className="SettlementQuoteInfoDetails">
            <div className="SettlementQuoteInfoAmount">
              <div className="SettlementQuoteTitle">
                {t('AMOUNT_REQUIRED_LABEL')}
              </div>
              <div className="SettlementQuoteSubTitle">
                {formatCurrency(props.automateSettlementInfo?.netPayoffAmount)}
              </div>
            </div>
            <div className="SettlementQuoteInfoValidDate">
              <div className="SettlementQuoteTitle">{t('VALID_UNTIL')}</div>
              <div className="SettlementQuoteSubTitle">
                {dateFormatter(props.automateSettlementInfo?.expiryDate)}
              </div>
            </div>
            <Button
              id="downloadSettlementQuote"
              variant="secondary"
              onClick={() => download()}
              disabled={isLoading}
              startIcon={
                isLoading ? (
                  <CircularProgress size="small" style={{color: '#000000'}} />
                ) : (
                  <Download />
                )
              }
            >
              {t('DOWNLOAD_PDF')}
            </Button>
          </div>
        </>
      ) : (
        <div className="SettlementQuoteTitle">
          {t('SETTLEMENT_QUOTE_VALUE_NOT_AVAILABLE')}
        </div>
      )}
    </div>
  ) : null;
};

export const mapStateToProps = (state) => {
  return {
    country: state.appStates.allContracts?.countryCode,
    contractNumbers: state.appStates.contractNumbers,
    userDetails: state.appStates.userDetailsInfo,
    customerDetails: state.appStates.myAccountDetails,
    selectedOrg: state.appStates.selectedOrg,
    contractDetails: state.appStates.contractDetails,
  };
};

export default connect(mapStateToProps)(SettlementQuoteInfo);
